import { gql } from '@at/sauron-platform-graphql'

export const dealerInfoQuery = gql`
    query DealerInfoQuery($dealerId: String!) {
        search {
            dealer(dealerId: $dealerId) {
                name
            }
        }
    }
`
